import { Link } from "react-router-dom";
import PostRequest from "../../../components/common/PostRequest"
import RequestList from "../../../components/common/RequestList"
import Footer from "../../../layout/footer"
import Header from "../../../layout/header"
import Sidebar from "../../../layout/sidebar"

const vendorDashboard = () => {
    return (
        <div className="header-author-layout">
            <div className="header-author">
                <Header />
            </div>

            <div className="content author-dashboard">
                <div className="row">
                    <div className="col-lg-2 p-0">
                        <Sidebar />
                    </div>
                    <div className="col-lg-10 text-start p-4">
                        <div className="row">
                            <div className="col-lg-8">
                                <p><i className="fa fa-th-large me-2"></i>Dashboard</p>
                                <div></div>
                                <p><small>My Articles</small></p>
                                <RequestList />
                                <RequestList />
                                <p><small>My Tasks</small></p>
                                <RequestList />

                            </div>
                            <div className="col-lg-4">
                                <p>Posted Request<span className="float-end"><Link>View All</Link></span></p>
                                <div id="carouselArticleIndicators" className="carousel slide" data-bs-ride="carousel">
                                    <div className="carousel-indicators">
                                        <button type="button" data-bs-target="#carouselArticleIndicators" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
                                        <button type="button" data-bs-target="#carouselArticleIndicators" data-bs-slide-to="1" aria-label="Slide 2"></button>
                                    </div>
                                    <div className="carousel-inner">
                                        <div className="carousel-item active">
                                            <PostRequest />
                                            <PostRequest />
                                            <PostRequest />
                                        </div>
                                        <div className="carousel-item">
                                            <PostRequest />
                                            <PostRequest />
                                            <PostRequest />
                                        </div>
                                    </div>
                                    <button className="carousel-control-prev" type="button" data-bs-target="#carouselArticleIndicators" data-bs-slide="prev">
                                        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                        <span className="visually-hidden">Previous</span>
                                    </button>
                                    <button className="carousel-control-next" type="button" data-bs-target="#carouselArticleIndicators" data-bs-slide="next">
                                        <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                        <span className="visually-hidden">Next</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    )
}
export default vendorDashboard
